export default "__VITE_ASSET__C8WtsMuN__"